import React from "react";
import { useSelector, useDispatch } from "types/store";
import { Accordion } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
const DoubleCheckOptions = ({ disableButtons }) => {
    const dispatch = useDispatch();
    const minChars = useSelector((state) => chatGPTReducer.getDoubleCheckMinChars(state));
    const similarityScoreCutoff = useSelector((state) => chatGPTReducer.getDoubleCheckSimilarityScoreCutoff(state));
    return (React.createElement("div", { className: styles.chatSettingsItem },
        React.createElement(Accordion, { header: React.createElement("div", { className: styles.chatSettingsItemHeader }, "Double-Check Highlight Settings") },
            React.createElement("div", { className: styles.setting },
                React.createElement("div", { className: styles.settingFlex },
                    React.createElement("div", { className: styles.settingNarrowWrapper },
                        React.createElement("div", { className: styles.settingLabel }, "Minimum Character Length"),
                        React.createElement("div", { className: styles.settingInputSmall },
                            React.createElement(LineInput, { value: minChars, onChange: (val) => dispatch(chatGPTReducer.updateDoubleCheckMinChars(Number(val))), isDisabled: disableButtons }))))),
            React.createElement("div", { className: styles.setting, style: { paddingLeft: "10px", marginTop: "12px" } },
                React.createElement("div", { className: styles.settingFlex },
                    React.createElement("div", { className: styles.settingNarrowWrapper },
                        React.createElement("div", { className: styles.settingLabel }, "Fuzzy Match (Lower = Less Strict)"),
                        React.createElement("div", { className: styles.settingInputSmall },
                            React.createElement(LineInput, { value: similarityScoreCutoff, onChange: (val) => dispatch(chatGPTReducer.updateDoubleCheckSimilarityScoreCutoff(Number(val))), isDisabled: disableButtons }))))))));
};
export default DoubleCheckOptions;
